import React from "react";

import { faInfoCircle } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

type WorkflowsInfoPanelProps = {
	children: React.ReactNode;
};

/**
 * The inline "can't show you this page" panel used by the workflows pages when the
 * feature gate passes but the content can't be rendered (missing permissions,
 * missing workflow, load failure). `role="status"` so swapping the page content
 * for this message is announced rather than silently changing under a screen
 * reader.
 */
const WorkflowsInfoPanel = ({ children }: WorkflowsInfoPanelProps) => (
	<div className="p-6">
		<div role="status" className="flex w-[400px] gap-1.5 rounded-sm bg-primary-1 p-5">
			<FontAwesomeIcon icon={faInfoCircle} className="text-lg text-primary-7" />
			<div className="font-semibold">{children}</div>
		</div>
	</div>
);

export default WorkflowsInfoPanel;
